const _ = require('lodash');
import utils from "@/utils/utils.js";
import websockets from './websockets.js'
import storeHelpers from '@/utils/storeHelpers.js';
import version from "../../version.json";

var Event;
var AppVersion = version

export default {
    // Sets up the websocket and events, only to be called by App.vue
    // To be sent when the app starts up
    // added to:
    //      App.vue
    started: function(handle) {
        sendSimpleStat(handle, 'started')
    },


    // device info e.g. OS and build captured
    // added to:
    //      App.vue
    info: function (handle) {
        var dInfo = deviceInfo();
        var event = newEvent(handle);
        window.generalTypeEventsProtobuf.lookup('SemVersion').fields.version = dInfo.version.setAppVersion;
        if (event !== -1) {
            event.info = {
                platform: window.generalTypeEventsProtobuf.lookup('Platform').values.WEB,
                os: dInfo.setOs,
                device: dInfo.setBrowser,
                appVersion: window.generalTypeEventsProtobuf.lookup('SemVersion').fields
            }
            if (verify(event))
                sendStat(handle, event);
        } else {
            console.error("Error: Event not set");
        }
    },

    // When the user opens up the Library screen in the app
    // added to:
    //      Library.vue
    library: function(handle) {
        sendSimpleStat(handle, 'library')
    },

    // Resource screen on the app is opened
    // added to:
    //      BookResources.vue
    resources: function(handle) {
        sendSimpleStat(handle, 'resources');
    },

    // Upcoming events screen opened
    // added to:
    //      Calendar.vue
    upcomingEvents: function(handle) {
        sendSimpleStat(handle, 'upcomingEvents');
    },

    // Newsletter opened
    // added to:
    //      App.vue
    newsletter: function(handle) {
        sendSimpleStat(handle, 'newsletter');
    },

    // when user navigates to Groups 
    // added to:
    //      Groups.vue
    groupList: function(handle) {
        sendSimpleStat(handle, 'groupList');
    },

    // when user navigates to learning tools view
    // added to:
    //      LearningTools.vue
    learningTools: function(handle) {
        sendSimpleStat(handle, 'learningTools');
    },

    // Connected on MQTT
    hello: function(handle) {
        sendSimpleStat(handle, 'hello');
    },

    // Student stat page was opened
    // added to:
    //      Analytics.vue
    studentStats: function(handle) {
        sendSimpleStat(handle, 'studentStats');
    },

    // Free form content is loaded in the app - My Folders
    // added to:
    //      MyFolders.vue
    freeform: function(handle) {
        sendSimpleStat(handle, 'freeform');
    },
    
    // When the user adds a new folder in MyFolders
    // added to:
    //      MyFolders.vue - Not yet done
    addFolder: function(handle, folder, groupId, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.addFolder = {
                groupId: groupId,
                folderName: folder.title,
                folderId: folder.folderId,
                parentFolderId: folder.parentFolderId,
                location: location //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
        } else {
            console.error("Error: Event not set");
        }
    },

    // When the user renames a folder in MyFolders
    // added to:
    //      MyFolders.vue - Not yet done
    renameFolder: function(handle, folderId, groupId, oldFolderName, newFolderName, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
    
            event.renameFolder = {
                groupId: groupId,
                oldFolderName : oldFolderName,
                newFolderName: newFolderName,
                folderId: folderId,
                location: location //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // When the user renames a folder in MyFolders
    // added to:
    //      MyFolders.vue - Not yet done
    deleteFolder: function(handle, folderId, groupId, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.deleteFolder = {
                groupId: groupId,
                folderId: folderId,
                location: location //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // When the user moves an entire folder in MyFolders
    moveFolder: function(handle, folderId, groupId, oldParentFolderId, newParentFolderId, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.moveFolder = {
                groupId: groupId,
                folderId: folderId,
                oldParentFolderId: oldParentFolderId,
                newParentFolderId: newParentFolderId,
                location: location //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // When the user changes the description (at the top) of a folder in MyFolders
    // added to:
    //      MyFolders.vue - Not yet done (only fire when text actually changed)
    changeFolderDescription: function(handle, folderId, groupId, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.changeFolderDescription = {
                groupId: groupId,
                folderId: folderId,
                location: 0 //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // When the user adds a new file in MyFolders
    // added to:
    //      MyFolders.vue - Not yet done (get resource details)
    addFile: function(handle, folder, resource, groupId, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.addFile = {
                groupId: groupId,
                folderName: folder.title,
                folderId: folder.folderId,
                fileId: resource.id,
                fileType: resource.type,
                location: location //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // When the user renames a file in MyFolders
    // added to:
    //      MyFolders.vue - Not yet done (get old and new title)
    renameFile: function(handle, oldFileName, newFileName, groupId, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.renameFile = {
                groupId: groupId,
                oldFileName: oldFileName,
                newFileName: newFileName,
                location: location //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // When the user deletes a file in MyFolders
    // added to:
    //      MyFolders.vue - Not yet done
    deleteFile: function(handle, fileId, groupId, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.deleteFile = {
                groupId: groupId,
                fileId: fileId,
                location: location //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // When the user moves a file in MyFolders
    moveFile: function(handle, fileId, groupId, oldParentFolderId, newParentFolderId, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.moveFile = {
                groupId: groupId,
                fileId: fileId,
                oldParentFolderId: oldParentFolderId,
                newParentFolderId: newParentFolderId,
                location: location //NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },    

    // when a flashcard deck is renamed
    flashcardDeckRename: function(handle, resourceId, from, to) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.flashcardDeckRename = {
                resourceId: resourceId,
                from: from,
                to: to
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // when a flashcard deck is added / removed
    flashcardDeck: function(handle, resourceId, action = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.flashcardDeck = {
                resourceId: resourceId,
                action: action // UNDEFINED = 0
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // when a flashcard is added / removed from a deck
    flashcard: function(handle, resourceId, flashcardId, action = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.flashcard = {
                resourceId: resourceId,
                action: action, // UNDEFINED = 0
                flashcardId: flashcardId
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // when user navigates to learning tools view
    // added to:
    //      LearningTools.vue
    learningTools: function(handle) {
        sendSimpleStat(handle, 'learningTools');
    },

    // When the user searches in a Learning Path
    // added to:
    //      LearningPathFullscreen.vue - Not yet done
    searchLearningPath: function(handle, learningPathId, searchTerm, numberOfResults, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.searchLearningPath = {
                learningPathId: learningPathId,
                searchTerm: searchTerm, 
                numberOfResults: numberOfResults,
                location: location // NOT_SET
            }
            if (verify(event))
                sendStat(handle, event);
        } else {
            console.error("Error: Event not set");
        }
    },

    // When the user filters for a tag in a Learning Path 
    // added to:
    //      LearningPathFullscreen.vue - Not yet done
    filterLearningPath: function(handle, learningPathId, tags, resourceTypes, dueDateFrom, dueDateTo) {
        var event = newEvent(handle);
        if (event !== -1) {

            const timestampFrom = {
                seconds: Math.floor(dueDateFrom / 1000),
                nanos: (dueDateFrom % 1000) * 1e6
            }

            const timestampTo = {
                seconds: Math.floor(dueDateTo / 1000),
                nanos: (dueDateTo % 1000) * 1e6
            }

            event.filterLearningPath = {
                learningPathId: learningPathId,
                tags: tags, 
                resourceTypes: resourceTypes,
                dueDateFrom: timestampFrom,
                dueDateTo: timestampTo
            }
            if (verify(event))
                sendStat(handle, event);
        } else {
            console.error("Error: Event not set");
        }
    },
    
    // When the user toggles the Learning Path’s Full Screen mode
    // added to:
    //      LearningPathFullscreen.vue - Only for fullscreen
    learningPathViewToggle: function(handle, fullScreen) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.learningPathViewToggle = {
                fullScreen: fullScreen
            }
            if (verify(event))
                sendStat(handle, event);
        } else {
            console.error("Error: Event not set");
        }
    },

    focusGained: function(handle) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.focusGained = {
            }
            if (verify(event))
                sendStat(handle, event);
        } else {
            console.error("Error: Event not set");
        }
    },
    focusLost: function(handle) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.focusLost = {
            }
            if (verify(event))
                sendStat(handle, event);
        } else {
            console.error("Error: Event not set");
        }
    },
    // When a section of a book is opened, defining from where the action to
    // open the book was issued
    pageOpen: function(handle, bookId, page, from, loadTime, section, pageIndex) {
        
        var event = newEvent(handle);
        if (event !== -1) {
            event.pageOpen = {
                bookId: bookId,
                page: page,
                from: from,
                loadTime: loadTime,
                section: section,
                pageIndex: pageIndex
            };
            
            if (verify(event)){
                sendStat(handle, event);
            }
        } else {
            console.error("Error: Event not set");
        }
    },

    pageOpenByMethod: function(handle, method, bookId, currentPage, pageLoadTime, selector, location) {
        var t = this;
        switch (method) {
            case "TOC":
                t.pageOpen(handle, bookId, currentPage, 4, pageLoadTime, selector, currentPage);
                break;
            case "prevNav":
                t.pageOpen(handle, bookId, currentPage, 7, pageLoadTime, selector, currentPage);
                break;
            case "nextNav":
                t.pageOpen(handle, bookId, currentPage, 6, pageLoadTime, selector, currentPage);
                break;
            case "input":
                t.pageOpen(handle, bookId, currentPage, 14, pageLoadTime, selector, currentPage);
                break;
            case "redirect": 
                t.pageOpen(handle, bookId, currentPage, 2, pageLoadTime, selector, currentPage);
                break;
            case "scroll": 
                t.pageOpen(handle, bookId, currentPage, 9, pageLoadTime, selector, currentPage);
                break;
            case "scrubber": 
                t.pageOpen(handle, bookId, currentPage, 10, pageLoadTime, selector, currentPage);
                break;
            case "location":
                break;
            default:
                t.pageOpen(handle, bookId, currentPage, location, pageLoadTime, selector, currentPage);
                break;
        }
    },

    resourceOpen: function(handle, resource, from, externally) {
        var event = newEvent(handle);
        if (event !== -1) {
            from = !from ? 0 : from;
            event.resourceOpen = {
                resourceId: resource._id, 
                from: from, // NOT_SET
                category: resource.category,
                private: resource.private,
                externally: externally
            };

            if (verify(event)) {
                sendStat(handle, event);
            }
        } else {
            console.error("Error: Event not set");
        }
    },

    // When a user interacts with an item in a Learning Path
    // When an attachment is opened and the location from where
    attachmentOpen: function(handle, attachmentId, attachmentPrivate, attachmentCategory, from = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.attachmentOpen = {
                attachmentId: attachmentId,
                from: from, //NOT_SET
                category: attachmentCategory,
                private: attachmentPrivate
            };
            
            if (verify(event)) {
                sendStat(handle, event);
            }
        } else {
            console.error("Error: Event not set");
        }
    },

    // When a highlight is made / changed
    highlight: function(handle, hlId, bookId, section) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.highlight = {
                hlId: hlId,
                bookId: bookId,
                section: section
            }
            if (verify(event))
                sendStat(handle, event);
        } else {
            console.error("Error: Event not set");
        }
    },

    // A url is opened outside of the app. This excludes URL resources.
    externalURLOpen: function(handle, url, location = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.externalURLOpen = {
                url: url,
                location: location //NOT_SET
            }
            if (verify(event)) {
                sendStat(handle, event);
            }
        } else {
            console.error("Error: Event not set");
        }
    },

    lastWill: function(handle, username, deviceId) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.lastWill = {
                info: deviceInfo(),
                username: username,
                deviceId: deviceId
            }
            if (verify(event))
                sendStat(handle, event);
            } else {
            console.error("Error: Event not set");
        }
    },

    // An annotation is adjusted in some way
    annotation: function(handle, attachmentId, action = 0) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.annotation = {
                attachmentId: attachmentId,
                action: action //NOT_SET
            };

            if (verify(event)) {
                sendStat(handle, event);
            }
        } else {
            console.error("Error: Event not set");
        }
    },

    //learningPathProgressChanged
    learningPathProgressChanged: function(handle, learningPathId, learningPathItemId, attachmentId, progress) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.learningPathProgressChanged = {
                learningPathId: learningPathId,
                learningPathItemId: learningPathItemId,
                attachmentId: attachmentId,
                progress: progress
            }
            if (verify(event)) {
                sendStat(handle, event);
            }
        } else {
            console.error("Error: Event not set");
        }
    },

    // Upon opening a summary
    summary: function(handle) {
        sendSimpleStat(handle, 'summary');
    },

    // User requests the saving of summary to PDF
    savePDF: function(handle) {
        sendSimpleStat(handle, 'savePDF');
    },

    bookExpired: function(handle, bookId, expiryDate, deletedDate) {
        var event = newEvent(handle);
        if (event !== -1) {
            event.bookExpired = {
                bookID: bookId,
                expiryDate: expiryDate,
                deletedDate: deletedDate
            }
            if (verify(event)) {
                sendStat(handle, event);
            }
        } else {
            console.error("Error: Event not set");
        }
    },





/*
//==================================================================================================\\
||============================================== Future ============================================||
\\==================================================================================================//
*/


    // Settings screen opened
    settings: function(handle) {
        sendSimpleStat(handle, 'settings');
    },


    // Request to print the PDF summary issued by user
    printSummary: function(handle, book, bookType = 0) {
        var event = newEvent(handle);
        event.printSummary = {
            attachmentId: attachment._id,
            bookType: bookType //NOT_SET
        };

        if (verify(event))
            sendStat(handle, event);
    },

    

    // When the user selects to archive an EF
    archiveEF: function(handle, group, archived) {
        var event = newEvent(handle);
        event.archiveEF = {
            archived: archived,
            groupId: group._id
        }
        if (verify(event))
            sendStat(handle, event);
    },

    // A url has been opened that should be opened in a Webview _within_
    // the app and not externally
    internalURLOpen: function(handle, url, location = 0) {
        var event = newEvent(handle);
        event.internalURLOpen = {
            url: url,
            location: location //NOT_SET
        }
        if (verify(event))
            sendStat(handle, event);
    },

    

    // When the user switches between old and new EF
    toggleEF: function(handle, group, old) {
        var event = newEvent(handle);
        event.toggleEF = {
            old: old,
            groupId: group._id
        }
        if (verify(event))
            sendStat(handle, event);
    },

    // When the user searches in a book
    searchBook: function(handle, bookId, searchTerm, numberOfResults, timeTakenMillis) {
        var event = newEvent(handle);
        event.searchBook = {
            bookId: bookId,
            searchTerm: searchTerm,
            numberOfResults: numberOfResults, 
            timeTakenMillis: timeTakenMillis //not yet implemented
        }
        if (verify(event))
            sendStat(handle, event);
    },

    // When the user shares a file in MyFolders // Not sure if this will be implemented
    shareFile: function(handle, groupId, fileId, location = 0) {
        var event = newEvent(handle);
        event.shareFile = {
            groupId: groupId,
            fileId: fileId,
            location: location //NOT_SET
        }
        if (verify(event))
            sendStat(handle, event);
    },

    // book error
    bookError: function(handle, bookId, errorString, errorType = 0) {
        var event = newEvent(handle);
        event.bookError = {
            bookId: bookId,
            errorString: errorString,
            errorType: errorType //OTHER
        }
        if (verify(event))
            sendStat(handle, event);
    },

    //When a group is archived by a user, a stat must be sent through to Analytics.
    archiveGroup: function(handle, archived, groupId) {
        var event = newEvent(handle);
        event.archiveGroup = {
            archived: archived,
            groupId: groupId
        }
        if (verify(event))
            sendStat(handle, event);
    },

    //LPItemViewStatus
    lPItemViewStatus: function(handle, learningPathItemId, learningPathId, isExpanded) {
        var event = newEvent(handle);
        event.lPItemViewStatus = {
            learningPathItemId: learningPathItemId,
            learningPathId: learningPathId,
            isExpanded: isExpanded
        }
        if (verify(event))
            sendStat(handle, event);
    },

    // Library archive screen opened
    libraryArchive: function(handle) {
        sendSimpleStat(handle, 'libraryArchive');
    },

    // When the user selects to archive a book
    archiveBook: function(handle, archived, bookId, filesDeleted) {
        var event = newEvent(handle);
        event.archiveBook = {
            archived: archived,
            bookId: bookId,
            filesDeleted: filesDeleted
        }
        if (verify(event))
            sendStat(handle, event);
    },

    // when user navigates to Groups Archive
    groupListArchive: function(handle) {
        sendSimpleStat(handle, 'groupListArchive');
    },

    // when user has generated logs
    sendLogs: function(handle) {
        sendSimpleStat(handle, 'sendLogs');
    },

    // User views the last generated PDF - summary
    viewLastPDF: function(handle) {
        sendSimpleStat(handle, 'viewLastPDF');
    },

    // When the troubleshooter is viewed - green dot at the bottom of the app
    troubleshooter: function(handle, opened) {
        var event = newEvent(handle);
        event.troubleshooter = {
            opened: opened
        }
        if (verify(event))
            sendStat(handle, event);
    },
}

function sendSimpleStat(handle, type) {
    var event = newEvent(handle)
    if (event !== -1) {
        event[type] = {};
        sendStat(handle, event);
    } 
}

function sendStat(handle, event) {
    if (!utils.isParentApp() && storeHelpers.getAnalytics(handle)) {
        websockets.send("analytics", Event.encode(event).finish());
    } else {
        console.error("not sending stats, because of temppassword used")
    }
}

function newEvent(handle) {
    if (window && window.deviceEventsProtobuf) {
        Event = window.deviceEventsProtobuf.lookupType("Event");
        var event = {
            common: common(handle)
        }
        return event;
    }
    return -1;
}

function common(handle) {
    if (window && window.deviceEventsProtobuf) {
        var Common = window.deviceEventsProtobuf.lookupType("Common");

        var common = { };
        common.username = handle.$store.state.user.username;

        const timeMS = new Date().getTime();
        const timestamp = {
            seconds: Math.floor(timeMS / 1000),
            nanos: (timeMS % 1000) * 1e6
        }

        common.timestamp =  timestamp;
        common.deviceId = handle.$store.state.uniqueId;

        var errMsg = Common.verify(common);

        if(errMsg) {
            console.error(errMsg);
        }
        return common;
    }
    return -1;
}

function verify(event) {
    var errMsg = Event.verify(event);
    if (errMsg) {
        console.error(errMsg);
        return false;
    }
    return true;
}

//??? https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript ???
function deviceInfo() {
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = '' + parseFloat(navigator.appVersion);
    var nameOffset, verOffset, ix;

    // Opera
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    if ((verOffset = nAgt.indexOf('OPR')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
    }
    // Edge
    else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
        browser = 'Microsoft Edge';
        version = nAgt.substring(verOffset + 5);
    }
    // MSIE
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
    }
    // Chrome
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
    }
    // Safari
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Firefox
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf('Trident/') != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
    // Other browsers
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

    // system
    var os = 'Other';
    var clientStrings = [
        {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
        {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
        {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
        {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
        {s:'Windows Vista', r:/Windows NT 6.0/},
        {s:'Windows Server 2003', r:/Windows NT 5.2/},
        {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
        {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
        {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
        {s:'Windows 98', r:/(Windows 98|Win98)/},
        {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
        {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s:'Windows CE', r:/Windows CE/},
        {s:'Windows 3.11', r:/Win16/},
        {s:'Android', r:/Android/},
        {s:'Open BSD', r:/OpenBSD/},
        {s:'Sun OS', r:/SunOS/},
        {s:'Linux', r:/(Linux|X11)/},
        {s:'iOS', r:/(iPhone|iPad|iPod)/},
        {s:'Mac OS X', r:/Mac OS X/},
        {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s:'QNX', r:/QNX/},
        {s:'UNIX', r:/UNIX/},
        {s:'BeOS', r:/BeOS/},
        {s:'OS/2', r:/OS\/2/},
        {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/},
    ];

    _.each(clientStrings, function(id) {
        if (id.r.test(nAgt)) {
            os = id.s;
            return false;
        }
    })


    var info = {
        setPlatform: 5,
        setOs: os,
        version: {
            setAppVersion: AppVersion.version
        },
        setBrowser: browser
    }
    return info;
}